import { Phone } from "lucide-react";
import { PHONE_DISPLAY, PHONE_TEL, IMAGES } from "../../data/site";

export const Seniors = () => (
    <section id="seniors" data-testid="seniors-section" className="bg-white">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 py-10 md:py-16">
            <div className="grid lg:grid-cols-5 gap-10 items-center">
                <div className="lg:col-span-3">
                    <h2 className="font-heading text-3xl md:text-4xl font-semibold tracking-tight text-[#0F2E52] mb-4">
                        Patient Computer Help
                    </h2>
                    <div className="space-y-3 text-base md:text-lg leading-relaxed text-slate-700 mb-5">
                        <p>
                            Technology can be frustrating, particularly when instructions assume everyone already
                            knows how everything works.
                        </p>
                        <p>
                            We're happy to explain things clearly and take the time to help with computers, email,
                            printers, Wi-Fi, new devices and everyday technology.
                        </p>
                        <p className="font-medium text-[#0F2E52]">No jargon and no rushing.</p>
                    </div>
                    <a
                        href={PHONE_TEL}
                        data-testid="seniors-call-link"
                        className="inline-flex items-center gap-2 text-blue-600 font-semibold hover:underline"
                    >
                        <Phone className="w-4 h-4" />
                        Need help? Call {PHONE_DISPLAY}
                    </a>
                </div>
                <div className="lg:col-span-2 relative">
                    <div className="absolute -bottom-3 -right-3 w-full h-full bg-blue-50 rounded-3xl" aria-hidden="true" />
                    <img
                        src={IMAGES.senior}
                        alt="Senior comfortably using a laptop at home with patient computer help"
                        data-testid="seniors-image"
                        className="relative rounded-2xl w-full object-cover aspect-[4/3] shadow-sm border border-slate-100"
                        loading="lazy"
                    />
                </div>
            </div>
        </div>
    </section>
);
